import React, { FC } from 'react';
import * as styles from '@/newcar/ui/contract/components/Footer/index.module.styl';
import privacymark from '@/newcar/ui/contract/img/privacymark.png';

// 申込みフォーム用のフッター
const Footer: FC = () => (
  <>
    <div className={`is-valign-center is-margin-left-5 is-margin-right-5 ${styles.privacymarkArea}`}>
      <a href="https://privacymark.jp/" className={styles.privacymarkImg}>
        <img src={privacymark} alt="プライバシーマーク" />
      </a>
      <p className="is-size-7 has-text-grey">
        ナイル株式会社はプライバシーマーク付与事業者です。
        <br />
        入力情報はSSL暗号化によりプライバシー保護されます。
      </p>
    </div>
    <div className="has-text-centered">
      <small className="is-size-7 has-text-grey">©︎2018- Nyle Inc.</small>
    </div>
  </>
);

export default Footer;
